// custom: T8a — helper de filtro local estilo WhatsApp para a lista de conversas
//
// Filtra a lista já carregada em ChatList.vue por nome resolvido do contato,
// phone_number, e conteúdo da última mensagem. Sem chamada à rede — instantâneo.
// Server-side (histórico completo) é o PR3b.

import { resolveContactName } from 'dashboard/composables/cw_custom/resolveContactName';
import { getLastMessage } from 'dashboard/helper/conversationHelper';

/**
 * Normaliza uma string para comparação: minúsculas + remove acentos.
 * @param {string} s
 * @returns {string}
 */
function normalize(s) {
  return String(s == null ? '' : s)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/**
 * Retorna apenas os dígitos de uma string.
 * @param {string} s
 * @returns {string}
 */
function digits(s) {
  return String(s == null ? '' : s).replace(/\D/g, '');
}

/**
 * Verifica se uma conversa bate com a query de busca.
 *
 * Critérios (qualquer um):
 *   - Nome resolvido do contato (via resolveContactName)
 *   - phone_number (com máscara e sem — compara só dígitos)
 *   - Conteúdo da última mensagem
 *
 * @param {Object} conversation - objeto de conversa da store
 * @param {string} q - query já trimada (caller garante não-vazia)
 * @returns {boolean}
 */
export function matchesQuery(conversation, q) {
  if (!q) return true;

  const qNorm = normalize(q);
  const qDig = digits(q);

  // Resolver o contato a partir de conversation.meta.sender (shape da store)
  const sender = conversation?.meta?.sender ?? {};
  const contact = {
    name: sender.name,
    phone_number: sender.phone_number,
    additional_attributes: sender.additional_attributes,
  };

  // 1) Nome resolvido do contato
  const resolvedName = resolveContactName(contact);
  if (normalize(resolvedName).includes(qNorm)) return true;

  // 2) Número de telefone — com máscara (substring) e sem (só dígitos)
  const phone = String(sender.phone_number == null ? '' : sender.phone_number);
  if (phone && normalize(phone).includes(qNorm)) return true;
  if (qDig && phone && digits(phone).includes(qDig)) return true;

  // 3) Conteúdo da última mensagem
  // Guard defensivo: getLastMessage acessa m.messages[m.messages.length-1];
  // conversas sem a chave messages (ex.: resultados do SearchAPI) causariam
  // TypeError e derrubariam o computed inteiro.
  const lastMsg = conversation?.messages?.length
    ? getLastMessage(conversation)
    : null;
  const content = lastMsg?.content ?? '';
  if (content && normalize(content).includes(qNorm)) return true;

  return false;
}
